(ns rlws.iot-cloud.frontend.main
  (:require [com.smxemail.re-frame-cookie-fx]
            [day8.re-frame.http-fx]
            [re-frame.core :as rf]
            [re-pressed.core :as rp]
            [reagent.dom :as r]
            [rlws.iot-cloud.frontend.authentication :as authn]
            rlws.iot-cloud.frontend.events
            rlws.iot-cloud.frontend.fx
            [rlws.iot-cloud.frontend.navigation :as nav]
            [rlws.iot-cloud.frontend.storage :as storage]
            [rlws.iot-cloud.frontend.views :as views]))

(def app-name "rlws-cloud")

(defn mount-root
  []
  (when-let [section (js/document.getElementById "app")]
    (rf/clear-subscription-cache!)
    (r/render [views/views] section)))

(defn ^:export init
  []
  (rf/dispatch-sync [::rp/add-keyboard-event-listener "keydown"])
  (rf/dispatch [:init])
  (nav/init-routes!)
  (storage/init-storage! app-name)
  (rf/reg-global-interceptor authn/http-interceptor)
  (mount-root))

(defn ^:dev/after-load re-render []
  (mount-root))

(defonce run (init))
